import Vue from 'vue'
import Vuex from 'vuex'

import references from "./references"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    references: null
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    references
  }
})